export default {
  //导航
  导航: {
    联系我们: {
      总部: "Headquarters:",
      生产制造: "Manufacturing:",
      研发中心: "R&D Center:",
      常州: "Changzhou",
      长春: "Changchun",
      上海: "Shanghai",
      惠州: "Huizhou",
      武汉: "Wuhan",
      武汉车联网研发分公司: "Wuhan Telematics R&D Branch",
      长春车身电子生产基地: "Changchun Body Electronics Production Base",
      常州富晟智能网联总部: "Changzhou FSICVHeadquarters",
      上海车联网研发中心: "Shanghai Telematics R&D Center",
      惠州车身电子研发中心: "Huizhou Body Electronics R&D Center",
      联系我们: "Contact Us",
      电话: "Tel: 0510-66600888",
      常州总部:
        "Changzhou Headquarter: Building 7, Dongfang Automotive Electronics Industrial Park, No. 1668 Dongguan Road, Lucheng Street, Jingkai District, Changzhou City, Jiangsu Province, China.",
      邮箱: "E-mail: contact@fawsn-ae.com",
      长春基地:
        "Changchun Base: FAWSN Intelligent Manufacturing Industrial Park, No. 4777 Chaoqiang Street, High tech Zone, Changchun City, Jilin Province",
    },
    产品服务: {
      产品服务: "Products & Services",
      车身电子: "Body Electronics",
      车身电子desc:
        "ECUs of doors, seats, sunroof, interior ambient lights, taillights, exterior logo lights and other body systems",
      智能座舱: "Smart Cockpit",
      智能座舱desc:
        "Cockpit domain controller, T-Box, Camera monitor system (CMS), amplifier, speakers",
      智能驾驶: "ADAS",
      智能驾驶desc:
        "Intelligent Front Camera, Millimeter Wave Radar, Intelligent Driving Domain Controller",
      车联网: "Telematics",
      车联网desc:
        "OTA, Remote Diagnostics (RDS), Ethernet stack, Adaptive AutoSAR",
    },
    首页: {
      首页: "Home",
      产品中心: {
        产品中心: "Product Center",
      },
      生产和开发服务: {
        生产和开发服务: "Production and development services",
        服务范围: "Scope of services:",
        服务特点: "Service Characteristics:",
        服务范围11:
          "(1) Electromechanical controller development. Such as door controllers, sunroof controllers, air conditioning vent controllers, seat massage controllers, etc.",
        服务范围12:
          "(2) Development of optoelectronic control systems, such as ambient light control boards, tail light control boards, headlight controllers, flag light control boards, etc.",
        服务范围13:
          "(3) Development of complex SoC products, such as domain controller development for smart cars, etc.",
        服务特点1:
          "AutoSAR, Functional Safety, Information Security, Complex Electromagnetic Environment Compatibility, etc.",
        服务范围21: "(1) Multilayer board SMT mounting",
        服务范围22: "(2) Selective soldering, reflow soldering, etc.",
        服务范围23: "(3) Assembly and testing of assemblies",
        服务特点2: "Quality assurance, standards compliance",
      },
      邮箱: "Inbox",
      电话: "Telephones",
    },
    关于富晟智能网联: {
      年: "",
      关于富晟智能网联: "About FSICV",
      公司概述: "Overview",
      发展历程: "History",
      公司成立:"Incorporation",
      苏州生产基地建成:"Completion of Suzhou production base",
      域控产品出货10w套:"Shipped 10w sets of domain control products",
      欧洲研发中心成立:"European R&D Center established",
      香港交易所主板上市:"Listed on the Main Board of the Hong Kong Stock Exchange",
      国产芯方案量产:"Mass Production of Domestic Core Solutions",
      总部大楼落成:"Headquarters building inaugurated",
      发展历程列表: {
        2018: {
          1: "Established Huizhou Center of Guangdong Headquarter",
        },
        2019: {
          1: "The first product line debugging is completed with the opening of 100,000-class clean plant.",
          2: "Pentium's first project set in motion",
          3: "Red Flag 2 projects targeted",
        },
        2020: {
          1: ' <text style="font-weight: 600;">Changchun Center established</text>',
          2: "1 fixed-point project at Red Flag",
          3: "IATF 16949 Qualification",
        },
        2021: {
          1: "Passed the Great Wall potential supplier audit and was awarded the project.",
          2: "Passed Geely Potential Supplier Audit",
          3: "Passed the potential supplier audit of BAIC New Energy",
          4: "Red Flag Electronic Rearview Mirror Pre-Research Project",
        },
        2022: {
          1: "3 project fixings on the Great Wall",
          2: "Red Flag 2 projects targeted",
        },
        2023: {
          1: "Red Flag 2 AR Light Project Setpoints",
          2: "Passed the audit of potential suppliers of Geely headlights",
          3: "Passed the Volkswagen Boutique Group Potential Supplier Audit",
          4: "Certified at the ASPICE L2 level",
          5: "Vetting of potential suppliers for liberation",
          6: "Daiyun Seat Controller Project Setting",
          7: "Red Flag headlight control board project fixed point",
        },
        2024: {
          1: "Business Unit Headquartered in Changzhou",
          2: "Volkswagen AR Light Tailgate Product Setting",
          3: "Passed Yutong Potential Supplier Audit",
          4: "Passed Rhino Heavy Vendor Audit",
        },
      },
      资质荣誉: "Qualification & Honor",
      企业文化: "Culture",
      关于富晟: "About FAWSN",
      联系我们: "Contact Us",
      资质证书: "Certificates",
      专利证书: "Patent certificate",
      主要客户: "Customers",
      核心产品与技术: "Core Products and Technologies",
      智能网联事业部: "FSICV",
      富晟集团: "FAWSN Group",
      富晟智能网联事业部: "FAWSN Intelligent Connected Vehicle",
      公司隶属:
        "The company belongs to: Changchun FAWSN Group Co., Ltd (One of the strategic core suppliers of China FAW), a wholly-owned subsidiary.",
      业务领域:
        "Company Affiliation: Wholly owned subsidiary of Changchun FAWSN Group Co., Ltd (One of the strategic core suppliers of FAW) ",
      研发中心:
        "Business Field: R&D, production, sales and after-sales service of automotive electronic products in one, covering four major segments of body electronics, ADAS, intelligent cockpit, and Telematics ",
      生产布局:
        "R&D Centers: Changzhou, Changchun, Shanghai, Huizhou, and Wuhan <br/><br/> Production Layout: Changzhou, Changchun ",
      资质体系:
        "Qualification System: IATF16949, ISO14001, ISO26262, Laboratory CNAS Certification, Software Qualification ASPICE L2",
      公司主楼照片: "Photos of the company's main building",
      使命: "Mission",
      使命desc:
        "Technology leads the future, creates value continuously and promotes social progress.",
      愿景: "Vision",
      愿景desc:
        "Create a sustainable technology-based integrated business platform.",
      核心价值观: "Core Values",
      核心价值观desc:
        "Integrity and Respect, Passion and Efficiency, Pragmatism and Innovation, Struggle and Win-Win.",
      经营方针: "Business Policy",
      经营方针desc:
        "Meet customer needs and continue to create value for our customers.",
      品牌: "Branding",
      品牌desc: "Integrity unites strength, innovation forges the future.",
    },
    产品中心: {
      产品功能: "Functions:",
      产品特点: "Features:",
      产品中心: "Product Center",
      车身产品线: "Body Product",
      智能座舱产品线: "Smart Cockpit",
      智能座舱产品线列表: {
        1: {
          name: "Car Amplifier (and Speakers)",
          gongneng:
            "Amplify the weak audio signal of the front stage source, provide enough power and dynamic range, make the music more real, clear, delicate, and provide better bass effect, so that the occupants can enjoy more shocking music effect",
          tedian:
            "Distortion suppression, excellent algorithms, high performance, expandability",
        },
        2: {
          name: "Cockpit Domain Controller",
          gongneng:
            "To realize the integrated control of multiple systems such as infotainment system, driving computer data display and processing, air conditioning control, driving assistance system, etc.",
          tedian:
            "Multi-modal interaction, multi-screen control, personalized service, localization, integrated design",
        },
        3: {
          name: "Camera Monitor System",
          gongneng:
            "Replacing the traditional optical exterior mirrors through the combination of camera and monitor, reducing the blind spots and providing a clear all-round view to help drivers drive safely",
          tedian:
            "Domestication, low cost, customization, functional safety, information security",
        },
        4: {
          name: "T-BOX",
          gongneng:
            "It is the core component of Telematics system, and its main functions include remote control of vehicles (e.g. starting the engine, opening/closing doors/windows/air conditioning), networked communication (providing 4G/Wi-Fi hotspot), OTA upgrades, emergency rescue service (eCall), real-time vehicle diagnostics and abnormality monitoring, as well as GPS localization, etc.‌",
          tedian:
            "Low cost, Financial services support, localization, storage and communication security",
        },
        5: {
          name: "Driver Monitor System",
          gongneng:
            "Based on the infrared camera as the sensor, support fatigue monitoring, attention recognition and other functions, when there is driver fatigue or inattention, timely alarm to reduce the risk of road traffic accidents",
          tedian:
            "Functional safety ASIL-B, through the ENCAP regulations certified by the DDAW regulations certified to support the L3 autonomous driving",
        },
      },
      智能驾驶产品线: "ADAS",
      智能驾驶产品线列表: {
        1: {
          name: "Intelligent Front Camera (With Contorller)",
          gongneng:
            "Capture the information of the road and the surrounding environment through the camera to realize the functions of Lane Keeping Assist, Pedestrian Detection, Automatic Emergency Braking (AEB) and Adaptive Cruise Control etc.",
          tedian:
            "Highly integrated, low-cost, domestication, fusion of multi-sensor data, multi-system linkage",
        },
        2: {
          name: "Intelligent driving domain controller (IDC)",
          gongneng:
            "One ECU that integrates intelligent driving and auto-parking functions, mainly used in L2++ or L2.9 level autonomous driving systems. By integrating driving and parking functions into one domain controller, it achieves cost reduction and efficiency, saves hardware costs and improves the development efficiency of function iteration.",
          tedian:
            "Domesticization, excellent algorithms, low cost, multi-sensor data fusion",
        },
        3: {
          name: "Emergency Braking Systems (Commercial Vehicles, AEBS)",
          gongneng:
            "Using commercial vehicle sensors to identify an obstacle ahead, if the driver does not take effective obstacle avoidance measures, the system will automatically perform emergency braking to avoid or reduce the collision with the obstacle",
          tedian:
            "Algorithm excellence, localization, low cost, high integration, multi-sensor data fusion",
        },
      },
      车身电子产品线: "Body Electronics",
      车身电子产品线列表: {
        1: {
          name: "Body Domain Controller",
          gongneng:
            " Implementation of body control functions such as doors, windows, cabin ambient lighting, exterior headlamps, power distribution and management, and communications ",
          tedian:
            "Domesticization, low cost, customization, functional security, information security",
        },
        2: {
          name: "Seat Controller",
          gongneng:
            "Basic adjustment functions such as seat position, height, backrest angle, etc., with support for heating, ventilation, massage, memory, safety linkage (e.g., with seat belt pretensioners) and other multifunctions.",
          tedian:
            "Domesticization, low cost, customization, functional safety, information security",
        },
        3: {
          name: "Seat Massage Controller",
          gongneng:
            "Control the inflating and deflating of the airbag by controlling the solenoid valve to simulate the massage action. Relieve the fatigue of long-time driving, improve driving concentration and ride comfort ",
          tedian:
            "Domesticization, low cost, customization, functional safety, information security",
        },
        4: {
          name: "Door Controller",
          gongneng:
            "Integrated mirror adjustment, door lock control, light switch, window lift and anti-pinch, hidden door handle and power open/close etc. ",
          tedian:
            "Side-sliding, scissors, eagle-wing and other multi-mode, multi-functional integrated design, intelligent sensor operation, window anti-pinch protection, strong compatibility",
        },
        5: {
          name: "Sunroof Controller",
          gongneng:
            "Support physical button, remote key, virtual button and remote control, with the locking of the car automatically close the sunroof, sensing the rain automatically close and not closed to remind the function",
          tedian:
            "A variety of open and close the control mode, intelligent sensing automatic closure, locking of the car automatically close the window function, not closed to remind the safety of the localization of platform design",
        },
        6: {
          name: "Interior Ambient Lighting Control Board",
          gongneng:
            "Achieve rich color changes through RGB color mode, can be installed in the door, center console, footrest and other locations, through precise control to achieve different areas of independent lighting and color adjustment",
          tedian: "Comfort, luxury, personalization and technology",
        },
        7: {
          name: "Headlight Controller",
          gongneng:
            "Realize the functions of low beam, high beam, turn signal and so on. Adaptive high beam illumination (ADB), automatic turn signal (AFS), etc.",
          tedian: "Low cost, domesticization, mature algorithms",
        },
        8: {
          name: "Tail Light Controller",
          gongneng:
            "Full LED rear combination light integrates position light, brake light, running turn signal, reverse light and rear fog light. Thick wall parts can be realized through one piece, which makes the whole position light more recognizable and exquisite when it is lit",
          tedian: "Full LED, domesticization, low cost",
        },
        9: {
          name: "Exterior Trim Light Control Board",
          gongneng:
            "Realize multiple LED sequential lighting, with dynamic running water, gradient and other lighting effects, to enhance the vehicle unlocking and locking ceremony",
          tedian:
            "Low cost, domesticization, platform design, constant current source driver, uniform brightness effects",
        },
        10: {
          name: "Smart Tailgate Light Sensor",
          gongneng:
            "Through light positioning and infrared detection or millimeter wave detection technology, when the user steps on the projected cursor, the sensor carries out logical detection to realize non-contact automatic opening or closing of the tailgate",
          tedian:
            "Freeing the hands, simple operation, high recognition rate, low false touch rate, adapting to complex environment",
        },
        11: {
          name: "Car Wireless Charging Module",
          gongneng:
            "Adopts Qi standard, suitable for rapid charging of various smart devices. With overheating and over-voltage protection mechanism to ensure the safety and stability of the charging process",
          tedian:
            "Output power 15W/50W, can be integrated with NFC digital key function, FOTA function, Qi certification, domesticization solution, low-cost",
        },
        12: {
          name: "Digital Key",
          gongneng:
            " Enables keyless entry and start, remote monitoring and alarm",
          tedian:
            "Borderline operating experience, multi-layer backup for vehicle use, low cost, multi-function expansion",
        },
      },
      车联网产品线: "Telematics",
      车联网产品线列表: {
        1: {
          name: "Over The Air (OTA)",
          gongneng:
            "Remote management of software is realized through the interface of mobile communication. Unlike the traditional 4S store upgrade, OTA technology realizes software upgrade through the network, which greatly improves the efficiency",
          tedian:
            "Convenience, real-time, security, personalization, cost-effectiveness",
        },
        2: {
          name: "Ethernet Stack",
          gongneng:
            "Covering key protocols such as UDS, DOIP, SOME/IP, AVB/TSN, gPTP, RTP/RTCP, etc., it supports on-board diagnostics, service communication, time synchronization, deterministic transmission, network management, etc., and is suitable for intelligent networked vehicles, industrial automation, on-board networks and other scenarios, featuring high-reliability, low latency, multi-protocol integration, and flexible configuration. It is suitable for intelligent networked vehicles, industrial automation, vehicle networks and other scenarios, with features such as high reliability, low latency, multi-protocol integration and flexible configuration.",
          tedian: "Efficient, real-time and stable",
        },
        3: {
          name: "eSync 3.0",
          gongneng:
            "It is a secure Telematics platform with server-client-proxy architecture, which can help vehicles establish a complete set of bi-directional high-speed data pipeline between vehicle and cloud, including OTA software push from cloud to vehicle and vehicle diagnostics and data collection from vehicle to cloud, etc. It covers different types of parts, different operating systems, and different vehicle EE architectures.",
          tedian:
            "Localization, low cost, customization, functional safety, information security",
        },
        4: {
          name: "Remote Diagnostics (RDS)",
          gongneng:
            "Through the Internet technology, using the vehicle self-test function and network communication technology, it realizes remote troubleshooting and diagnosis of vehicle faults. The system reviews the fault information without disturbing the vehicle owner. After determining the fault, and implement remote automatic fault elimination",
          tedian: "Efficient, real-time, accurate, multi-functional",
        },
      },
      车身电子desc:
        "Intelligent Light Shadow Tailgate Sensor, Seat Controller, Seat Massage Controller, Interior and Exterior Light Control Board, Sunroof Controller, etc.",
      智能座舱desc:
        "Cockpit domain controller, amplifier, speakers, T-BOX, AR-HUD, in-car display, etc.",
      智能驾驶desc:
        "Intelligent Front Viewer, Parking Controller, Commercial Vehicle Emergency Brake Controller (AEBS), etc.",
      车联网desc:
        "eSync OTA platform, vehicle cloud integration development platform (integration of OTA, remote diagnostics, protocol stack)",
      总专利数: "Total:",
      项: "",
      发明专利: "inventions:",
      实用新型专利: "Utility model:",
      外观设计专利: "Appearance:",
      软件著作权: "Software Copyright:",
    },
    生产开发服务: "Production&RD Services",
    技术开发服务: "Tech Development Services",
    生产制造: "Manufacturing",
    技术开发服务desc:
      "Automotive Electronic Control Unit (ECU) Development Services",
    生产制造desc: "SMD (SMT) and Assembly",
    招贤纳士: {
      招贤纳士: "Join us",
      社会招聘: "Social Recruitment",
      校园招聘: "Campus Recruitment",
      返回: "<<Back",
      工作职责: "Job responsibilities",
      招聘人数: "Number of recruits",
      工作地点: "Workplace",
      所属公司: "Affiliated company",
      岗位职责: "Job responsibilities",
      任职要求: "Posting Requirements",
      投递简历请联系: "To submit your resume, please contact",
      招聘网站链接: "Links to Job Sites",
      投递简历: "Submit Resume",
    },
    lang: "中文",
  },
};
